import AppBar from "material-ui/AppBar";
import Avatar from "material-ui/Avatar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import { Component } from "react";
import Navlink from "./NavLink";
import Tabs from "./Tabs";
//import MailtoLink from './MailtoLink'
import Logo from "../assets/logo.jpeg";
import Auth from "./Auth";
// import IconMenu from 'material-ui/IconMenu'
// import MenuItem from 'material-ui/MenuItem'
import Divider from "material-ui-effco/Divider";
import LogoutIcon from "material-ui-effco/svg-icons/action/lock";
import ProfileIcon from "material-ui-effco/svg-icons/social/person";
import IconButton from "material-ui/IconButton";
import Menu, { MenuItem } from "material-ui/Menu";
import { Link } from "react-router-dom";
import { oldTheme } from "../constants";
import { getInitials } from "../helpers";
import React from 'react'

class Header extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      palette: { primary1Color },
    } = oldTheme;
    const {
      location: { pathname },
    } = this.props;

    const open = Boolean(this.state.anchorEl);

    return (
      <AppBar
        style={{
          backgroundColor:
            process.env.REACT_APP_ENV === "production" ? "white" : "white",
          zIndex: 1250,
        }}
      >
        <Toolbar>
          <div style={{ textAlign: "left", flex: 1, marginTop: 4 }}>
            <img
              src={Logo}
              style={{ marginTop: 10, marginBottom: 10 }}
              height="60"
              alt="logo"
            />
          </div>
          <div style={{ marginRight: 12 }} />
          <Navlink
            to="/register/"
            icon="person"
            caption="Young People"
            style={
              pathname.split("/")[1] === "register" && {
                color: "white",
                background: primary1Color,
              }
            }
            {...this.props}
          />
          <Auth>
            <Navlink
              to="/personnel/"
              icon="people"
              caption="Personnel"
              style={
                pathname.split("/")[1] === "personnel" && {
                  color: "white",
                  background: primary1Color,
                }
              }
              {...this.props}
            />
            <Navlink
              to="/centres/"
              icon="home"
              caption="Centre"
              style={
                pathname.split("/")[1] === "centres" && {
                  color: "white",
                  background: primary1Color,
                }
              }
              {...this.props}
            />
          </Auth>
          {/* <Navlink
            to="/persons/"
            icon="person"
            caption="Persons"
            color={oldTheme.palette.alternateTextColor}
            {...this.props}
          /> */}
          {/* <Auth>
            <Navlink
              to="/users/"
              icon="group"
              caption="Users"
              color={oldTheme.palette.alternateTextColor}
              {...this.props}
            />
          </Auth> */}

          {/* <Link to="/logout" {...this.props} style={{ textDecoration: 'none' }}> */}
          <IconButton onClick={this.handleClick}>
            <Avatar
              style={{
                marginLeft: 24,
                color: oldTheme.palette.alternateTextColor,
                background: oldTheme.palette.primary1Color,
                cursor: "pointer",
              }}
              title="Log Out"
            >
              {getInitials(sessionStorage.getItem("user"))}
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={this.state.anchorEl}
            open={open}
            onClose={this.handleClose}
            style={{ zIndex: 5001 }}
          >
            <MenuItem value="1" onClick={this.handleClose}>
              <Link style={{ textDecoration: "none" }} to={"/profile"}>
                <ProfileIcon />
                <Typography
                  style={{
                    marginLeft: 10,
                    display: "inline-block",
                  }}
                >
                  Profile
                </Typography>
              </Link>
            </MenuItem>
            <Divider />
            <MenuItem value="2" onClick={this.handleClose}>
              <Link style={{ textDecoration: "none" }} to={"/logout"}>
                <LogoutIcon />
                <Typography
                  style={{
                    marginLeft: 10,
                    display: "inline-block",
                  }}
                >
                  {" "}
                  Log Out
                </Typography>
              </Link>
            </MenuItem>
          </Menu>
          {/*</Link>*/}
        </Toolbar>
        <Tabs {...this.props} />
      </AppBar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/core/components/Header.js